module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-metals.451f165d.png";